export enum Game {
  None,
  YesNo,
  Debate,
  Picture,
}

export const gameInfo = [
  { label: 'Voice Note', value: Game.None },
  { label: 'Yes/No Game', value: Game.YesNo },
  { label: 'Debate Game', value: Game.Debate },
  { label: 'Say It, See It', value: Game.Picture },
];
